import script from "./DisableTwoFactorModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DisableTwoFactorModal.vue?vue&type=script&setup=true&lang=js"

import "./DisableTwoFactorModal.vue?vue&type=style&index=0&id=4bde1203&lang=css"

const __exports__ = script;

export default __exports__